import { datadogRum } from '@datadog/browser-rum';

type DDUser = {
  email?: string;
  id?: string;
};

const setDDUser = (user: DDUser) => {
  datadogRum.setUser({ ...user });
};

export { setDDUser };
